import React from "react"
import { InstantSearch } from "react-instantsearch"

import { useAlgoliaInsights } from "@services/algolia-insights"

/**
 * `<InstantSearch>` with Algolia Insights wired in behind the CookieYes
 * analytics consent gate.
 *
 * Use this instead of `<InstantSearch>` for every search experience. Mounting
 * insights is what sets `clickAnalytics` on the query, which is what makes
 * Algolia return a queryID - without it the search is untracked and no click
 * can ever be credited to it, so Click-through Rate stays empty.
 *
 * It also keeps the consent check in one place: the desktop header search bar
 * is still a class component and cannot call the hook itself.
 *
 * @param {Object} props - Forwarded to `<InstantSearch>` unchanged.
 */
const TrackedInstantSearch = ({ children, ...props }) => {
  const insights = useAlgoliaInsights()

  return (
    <InstantSearch {...props} insights={insights}>
      {children}
    </InstantSearch>
  )
}

export default TrackedInstantSearch
